import { Component, OnInit, inject } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { NgxSpinnerService, NgxSpinnerComponent } from "ngx-spinner";
import { AuthService } from "./auth/auth.service";
import { Subscription, switchMap, timer } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { PrimeNG } from "primeng/config";
import { LANGUAGES, setTranslator, translatePopups } from "./i18n/i18n";

@Component({
    standalone: true,
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    imports: [RouterOutlet, NgxSpinnerComponent]
})
export class AppComponent implements OnInit {
  route = inject(Router);
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router);
  private authService = inject(AuthService);
  private translate = inject(TranslateService);
  private primeng = inject(PrimeNG);

  flag = true;
  refreshSub: Subscription;

  constructor() {
    const supported = LANGUAGES.map((l) => l.value);
    this.translate.addLangs(supported);
    this.translate.setDefaultLang("it");
    setTranslator(this.translate);
    translatePopups();

    const saved = localStorage.getItem("selectedLang");
    const browser = this.translate.getBrowserLang();
    const lang = supported.includes(saved) ? saved : supported.includes(browser) ? browser : "it";
    localStorage.setItem("selectedLang", lang);

    // date picker month and day names follow the language
    this.translate.onLangChange.subscribe(() => {
      this.translate.get("calendar").subscribe((res) => this.primeng.setTranslation(res));
    });
    this.translate.use(lang);
  }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.authService.startTokenAutoRefresh();
    }
  }
  onActivate(event) {
    window.scroll(0, 0);
    document.body.scrollTop = 0;
    document.querySelector("body").scrollTo(0, 0);
  }
}
